import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Reveal } from "./Reveal";

const BG =
  "https://images.pexels.com/photos/30766684/pexels-photo-30766684.png?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";

const chapters = [
  {
    no: "01",
    label: "The Mission",
    lead: (
      <>
        To <span className="font-serif italic text-brand-volt">empower local commerce</span> by
        creating the fastest, most reliable neighborhood delivery network —
      </>
    ),
    tail: (
      <>
        turning every local store into a powerhouse of convenience called a{" "}
        <span className="text-brand-volt">Brightspot</span>.
      </>
    ),
  },
  {
    no: "02",
    label: "The Vision",
    lead: (
      <>
        A world where <span className="font-serif italic text-brand-volt">“local” means “instant”</span> —
      </>
    ),
    tail: (
      <>
        and every neighborhood business thrives in the{" "}
        <span className="font-serif italic text-brand-bone">digital economy</span>, powered by
        Zeroomile.
      </>
    ),
  },
];

export const Manifesto = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const bgY = useTransform(scrollYProgress, [0, 1], ["-15%", "15%"]);

  return (
    <section
      id="manifesto"
      ref={ref}
      data-testid="manifesto-section"
      className="relative overflow-hidden border-y border-brand-line bg-brand-surface/40 py-24 md:py-36"
    >
      <motion.img
        style={{ y: bgY }}
        src={BG}
        alt=""
        aria-hidden="true"
        className="pointer-events-none absolute inset-0 h-[130%] w-full object-cover opacity-[0.14]"
      />
      <div className="pointer-events-none absolute inset-0 bg-brand-bg/40" />

      <div className="relative mx-auto max-w-[1400px] px-6 md:px-12">
        <Reveal>
          <p className="mb-16 text-xs uppercase tracking-[0.3em] text-brand-muted">
            Why we exist
          </p>
        </Reveal>

        <div className="space-y-24">
          {chapters.map((c, i) => (
            <div
              key={c.no}
              className="grid grid-cols-1 gap-6 md:grid-cols-12 md:gap-10"
            >
              <Reveal className="md:col-span-3" y={30}>
                <div className="flex items-baseline gap-4 md:flex-col md:gap-2">
                  <span className="font-display text-7xl leading-none text-brand-volt md:text-8xl">
                    {c.no}
                  </span>
                  <span className="text-xs uppercase tracking-[0.3em] text-brand-muted">
                    {c.label}
                  </span>
                </div>
              </Reveal>
              <Reveal className="md:col-span-9" delay={0.1} y={40}>
                <p className="font-display text-4xl uppercase leading-[1.05] tracking-tight text-brand-bone sm:text-5xl md:text-6xl">
                  {c.lead} {c.tail}
                </p>
              </Reveal>
              {i === 0 && <div className="h-px bg-brand-line md:col-span-12" />}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
